import React from 'react'
import { useEffect, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { getAgentsAndQueuesByAccount, getUser } from "../../util/helpers";
import { addAgentToConference, CallFlow } from "./CallService";
import * as constants from "./constants";
import {
  getAgentPhone,
  getName,
  GetQueuePhotoOrInitial,
  getSortedAgentList,
  getStatusClass
} from "./helpers";
import { LiveCallMinimized } from "./LiveCallMinimized";
import { actionTypes } from "./reducer";

import PropTypes from "prop-types";
import { TelInput } from "./TelInput";

const useStyles = makeStyles({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "0px",
    backgroundColor: "#f3f6f9",
    border: "solid 1px #ccd6e3",
  },
  input: {
    marginLeft: "0px",
    flex: 1,
    lineHeight: "2em",
  },
  iconButton: {
    padding: 10,
  },
});

export function AddConference(props) {
  const searchClasses = useStyles();
  const dispatch = useDispatch();
  const { callFlow } = props;

  const [subView, setSubView] = useState("default");

  const setViewState = (view_state) => {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: { view_state: view_state },
    });
  };

  const [q, setQ] = useState("");
  const [agents, setAgents] = useState([]);
  useEffect(() => {
    const agentsApi = async () => {
      let params = { limit: 20 };
      if (q) {
        q.replaceAll("+", "");
        let q1 = q.trim();
        let n = Number(q1);
        if (isNaN(n)) {
          params["first_name__icontains"] = q1;
        } else {
          params["phone__contains"] = q1;
        }
      }

      const queueBasedAgentsMap = {};

      if (
        callFlow.getCallSolutionName() === "obdcc" ||
        callFlow.getCallSolutionName() === "inbound_cc"
      ) {
        const agentsAndQueues = await getAgentsAndQueuesByAccount(
          getUser(),
          false
        );
        const queueBasedAgents = agentsAndQueues
          ? agentsAndQueues["agents"]
          : [];

        queueBasedAgents.map((agent) => {
          queueBasedAgentsMap[agent.agent_id] = agent;
        });
      }

      const response = await callFlow
        .getSolution()
        .CALL_ACTIONS.AGENT_LIST_API(callFlow, params);
      if (response && response.data && response.data.objects) {
        if (
          callFlow.getCallSolutionName() === "obdcc" ||
          callFlow.getCallSolutionName() === "inbound_cc"
        ) {
          const list = response.data.objects.filter(
            (a) =>
              a.id !== callFlow.state.session_agent.id &&
              queueBasedAgentsMap &&
              queueBasedAgentsMap["" + a.id] &&
              queueBasedAgentsMap["" + a.id]["queue"]
          );

          setAgents(getSortedAgentList(list));
        } else {
          const list = response.data.objects.filter(
            (a) => a.id !== callFlow.state.session_agent.id
          );

          setAgents(getSortedAgentList(list));
        }
      } else {
        setAgents([]);
      }
    };
    agentsApi();
  }, [q]);

  const onEvent = (event) => {
    let dialled_number2 = event["value"];
    setDialledNumber(event["value"]);
    if (!dialled_number2 || dialled_number2.length < 13) {
    } else {
      setStatus(200);
    }
  };

  let is_call_to_anynumber = useSelector((state) => {
    return state.auth.is_call_to_anynumber;
  });
  const [status, setStatus] = useState(null);
  const [dialled_number, setDialledNumber] = useState(null);

  const callExternal = () => {
    if (!dialled_number || dialled_number.length < 13) {
      setStatus(400);
      return;
    }
    let transfer_agent = {
      first_name: "Unknown",
      phone: dialled_number,
      source: "external",
    };

    dispatch({
      type: actionTypes.onCallViewState,
      payload: { transfer_agent: transfer_agent },
    });
    addAgentToConference(callFlow, transfer_agent, dispatch);
  };

  return (
    <>
      <div
        style={{ height: "100%" }}
        className="tmodal tmodal-dialog-scrollable call-ticker-dialog-sec"
      >
        <div style={{ height: "100%" }} className="tmodal-content">
          <LiveCallMinimized {...props} disableSymbols={true} />

          <div className="ticker-header-title">
            <div className="d-flex justify-content-between align-items-center">
              <div className="back-section">
                <div className="back-icon click-icon">
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      setViewState(constants.CALL_VIEW_STATES.CALL_VIEW);
                    }}
                  >
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/sr/icons/ticker-back.svg")}
                    />
                  </a>
                </div>
                <div className="back-label">Call Conference</div>
              </div>

              {is_call_to_anynumber && (
                <>
                  {subView !== "dialpad" && (
                    <div className="dial-pad dial-pad-inactive click-icon">
                      <a
                        href="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setSubView("dialpad");
                        }}
                      >
                        {" "}
                        <img
                          alt=""
                          className="dial-pad-icon"
                          src={toAbsoluteUrl("/media/sr/icons/dial-pad.svg")}
                        />
                      </a>
                    </div>
                  )}

                  {subView === "dialpad" && (
                    <div className="dial-pad dial-pad-active click-icon">
                      <a
                        href="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setSubView("default");
                        }}
                      >
                        {" "}
                        <img
                          alt=""
                          className="dial-pad-icon"
                          src={toAbsoluteUrl(
                            "/media/sr/icons/dial-pad-active.svg"
                          )}
                        />
                      </a>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {subView === "dialpad" && (
            <>
              <div className="dial-call-section d-flex justify-content-between flex-column px-10 pt-2 pb-10">
                <div className="col-12dd mt-5">
                  <div className="ticker-sub-header-title">
                    Dial to any phone
                  </div>
                  <TelInput
                    label="Phone Number"
                    onEvent={onEvent}
                    status={status}
                    showValidationMessage={true}
                  />
                </div>

                <div className="dial-call-btn direct-dial click-icon">
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      callExternal();
                    }}
                  >
                    <img
                      alt=""
                      className="dial-call-icon"
                      src={toAbsoluteUrl("/media/sr/icons/dial-call.svg")}
                    />
                  </a>
                </div>
              </div>
            </>
          )}
          {subView !== "dialpad" && (
            <>
              <div className="tmodal-header add-conference-search bold-phl">
                <Paper className={searchClasses.root} elevation={0}>
                  <IconButton
                    className={searchClasses.iconButton}
                    aria-label="Search Agent"
                  >
                    <SearchIcon />
                  </IconButton>
                  <InputBase
                    value={q}
                    onChange={(event) => {
                      setQ(event.target.value);
                    }}
                    className={searchClasses.input}
                    placeholder="Search Agent"
                    inputProps={{ "aria-label": "Search Agent" }}
                  />
                </Paper>
              </div>
              <div className="tmodal-body list-agents">
                {agents.map((agent, index) => (
                  <>
                    <div className="d-flex justify-content-between agent-entity">
                      <div className="d-flex align-items-center">
                        <div className="queue-indicator-sec">
                          <div
                            className={`queue-status-indicator ${getStatusClass(
                              agent.agent_status
                            )}`}
                          ></div>
                        </div>
                        <GetQueuePhotoOrInitial
                          agent={agent}
                          wrapCls="queue-dp-sec"
                          imgCls="queue-dp"
                        />

                        <div className="agent-detail">
                          <div className="agent-name">{getName(agent)}</div>
                          <div className="agent-number">
                            {getAgentPhone(agent, 25)}
                          </div>
                        </div>
                      </div>
                      {getStatusClass(agent.agent_status) ===
                        "status-available" && (
                        <div className="agent-transfer click-icon">
                          <a
                            href="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              addAgentToConference(callFlow, agent, dispatch);
                            }}
                          >
                            <img
                              alt=""
                              className="agent-transfer-icon"
                              src={toAbsoluteUrl(
                                "/media/sr/icons/call-transfer-white.svg"
                              )}
                            />
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

AddConference.propTypes = {
  callFlow: PropTypes.instanceOf(CallFlow),
};
